import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end mb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-filter" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "card d-flex"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list-ul" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_10 = { class: "text-gray-500" }
const _hoisted_11 = { class: "row mt-3 p-5" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "text-gray-700 mb-2" }
const _hoisted_15 = { class: "text-gray-500" }
const _hoisted_16 = {
  selected: "",
  value: ""
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "easy" }, "Easy", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "medium" }, "Medium", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "hard" }, "Hard", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "insane" }, "Insane", -1)
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "text-gray-700 mb-2" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Status ")
const _hoisted_25 = { class: "text-gray-500" }
const _hoisted_26 = {
  selected: "",
  value: ""
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "completed" }, "Owned", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "started" }, "Started", -1)
const _hoisted_29 = { value: "unstarted" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "text-gray-700 mb-2" }
const _hoisted_33 = { class: "col-md-2 d-flex justify-content-end align-items-end" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_36 = {
  key: 1,
  class: "indicator-label"
}
const _hoisted_37 = { class: "mt-10 text-center" }
const _hoisted_38 = { class: "row g-6 g-xl-9" }
const _hoisted_39 = {
  key: 0,
  class: "row mt-10"
}
const _hoisted_40 = { class: "col-md-12" }
const _hoisted_41 = {
  class: "",
  role: "alert"
}
const _hoisted_42 = { class: "alert-heading" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_45 = { class: "text-gray-500" }
const _hoisted_46 = { class: "text-gray-500" }
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "card-header border-0 pt-9" }
const _hoisted_49 = { class: "card-title m-0" }
const _hoisted_50 = {
  key: 0,
  class: "symbol symbol-50px w-50px bg-light border border-success"
}
const _hoisted_51 = ["src"]
const _hoisted_52 = {
  key: 1,
  class: "symbol symbol-50px w-50px bg-light border border-info"
}
const _hoisted_53 = ["src"]
const _hoisted_54 = {
  key: 2,
  class: "symbol symbol-50px w-50px bg-light border border-warning"
}
const _hoisted_55 = ["src"]
const _hoisted_56 = {
  key: 3,
  class: "symbol symbol-50px w-50px bg-light border border-danger"
}
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "card-toolbar" }
const _hoisted_59 = {
  key: 0,
  class: "badge badge-light-primary fw-bolder me-auto px-4 py-3"
}
const _hoisted_60 = {
  key: 1,
  class: "badge badge-light-success fw-bolder me-auto px-4 py-3"
}
const _hoisted_61 = {
  key: 2,
  class: "badge badge-light-warning fw-bolder me-auto px-4 py-3"
}
const _hoisted_62 = { class: "card-body p-9" }
const _hoisted_63 = { class: "fs-3 fw-bolder text-dark d-flex" }
const _hoisted_64 = { class: "dificulty mb-5 mt-3 d-flex" }
const _hoisted_65 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_66 = {
  key: 1,
  class: "badge badge-light-info"
}
const _hoisted_67 = {
  key: 2,
  class: "badge badge-light-warning"
}
const _hoisted_68 = {
  key: 3,
  class: "badge badge-light-danger"
}
const _hoisted_69 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_70 = {
  key: 4,
  class: "badge badge-light-success"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 fw-bold fs-5 mt-1 mb-7" }, null, -1)
const _hoisted_72 = { class: "d-flex flex-wrap mb-5 justify-content-center" }
const _hoisted_73 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-7 mb-3" }
const _hoisted_74 = { class: "fs-6 text-gray-800 fw-bolder" }
const _hoisted_75 = { class: "fw-bold text-gray-500" }
const _hoisted_76 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mb-3" }
const _hoisted_77 = { class: "fs-6 text-gray-800 fw-bolder" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-gray-500" }, "XP earned", -1)
const _hoisted_79 = {
  class: "h-4px w-100 bg-light mb-5",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "This project 50% completed"
}
const _hoisted_80 = ["aria-valuenow"]
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "text-gray-600 fs-6" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-shield" }, null, -1)
const _hoisted_85 = { class: "symbol-group symbol-hover justify-content-center" }
const _hoisted_86 = {
  class: "symbol symbol-35px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "Emma Smith"
}
const _hoisted_87 = ["src", "title"]
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("small", { class: "text-gray-600 fs-6" }, [
  /*#__PURE__*/_createTextVNode("First Blood "),
  /*#__PURE__*/_createElementVNode("i", { class: "las la-tint text-danger" })
], -1)
const _hoisted_90 = { class: "symbol-group symbol-hover justify-content-center" }
const _hoisted_91 = {
  class: "symbol symbol-35px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "Emma Smith"
}
const _hoisted_92 = ["src", "title"]
const _hoisted_93 = { class: "pagination pagination-outline mt-10" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = ["innerHTML"]
const _hoisted_96 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_97 = { class: "justify-content-center d-flex flex-center" }
const _hoisted_98 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_99 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-secondary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show_filter = !_ctx.show_filter))
      }, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.filter`)) + " " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.machines`)), 1)
      ])
    ]),
    (_ctx.show_filter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h4", _hoisted_7, [
                  _hoisted_8,
                  _hoisted_9,
                  _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.machine_filter_desc`)), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.level`)) + " ", 1),
                  _createElementVNode("b", _hoisted_15, " - " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.machine`)) + " " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.difficulty`)), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doSearch())),
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.dificulty) = $event))
                }, [
                  _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.all`)), 1),
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20
                ], 544), [
                  [_vModelSelect, _ctx.filter.dificulty]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("b", _hoisted_25, " - " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.progress_on_this_machine`)), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doSearch())),
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter.status) = $event))
                }, [
                  _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.all`)), 1),
                  _hoisted_27,
                  _hoisted_28,
                  _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.not_started_yet`)), 1)
                ], 544), [
                  [_vModelSelect, _ctx.filter.status]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.search_by_tag`)), 1),
                _withDirectives(_createElementVNode("input", {
                  onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.doSearch())),
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filter.search) = $event)),
                  placeholder: "Windows, Linux, Machine name, etc..."
                }, null, 544), [
                  [_vModelText, _ctx.filter.search]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("button", {
                  type: "button",
                  ref: "submitSearchButton",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doSearch())),
                  id: "kt_search_in_submit",
                  class: "btn btn-lg btn-outline-info"
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.search`)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.searching`)) + "... ", 1))
                    : _createCommentVNode("", true)
                ], 512)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        (!_ctx.machines)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("h4", _hoisted_42, [
                    _hoisted_43,
                    _hoisted_44,
                    _createElementVNode("a", _hoisted_45, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.no_machines_found`)), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("a", _hoisted_46, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.try_change_filters_search_another_machine`)), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.machines, (machine) => {
          return (_openBlock(), _createElementBlock("div", {
            key: machine.id,
            class: "col-md-6 col-xl-4"
          }, [
            _createElementVNode("a", {
              href: '/laboratory/competition-machines/' + machine.id,
              class: "card border-hover-primary",
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  (machine?.dificulty == 'easy')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("img", {
                          src: machine?.photo_path,
                          alt: "image",
                          class: "p-1"
                        }, null, 8, _hoisted_51)
                      ]))
                    : _createCommentVNode("", true),
                  (machine?.dificulty == 'medium')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("img", {
                          src: machine?.photo_path,
                          alt: "image",
                          class: "p-1"
                        }, null, 8, _hoisted_53)
                      ]))
                    : _createCommentVNode("", true),
                  (machine?.dificulty == 'hard')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _createElementVNode("img", {
                          src: machine?.photo_path,
                          alt: "image",
                          class: "p-1"
                        }, null, 8, _hoisted_55)
                      ]))
                    : _createCommentVNode("", true),
                  (machine?.dificulty == 'insane')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _createElementVNode("img", {
                          src: machine?.photo_path,
                          alt: "image",
                          class: "p-1"
                        }, null, 8, _hoisted_57)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_58, [
                  (
                  machine?.percentage > 0 &&
                  machine?.percentage < 100
                )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.in_progress`)), 1))
                    : _createCommentVNode("", true),
                  (machine?.percentage == 100)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.completed`)), 1))
                    : _createCommentVNode("", true),
                  (machine?.percentage == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.not_started_yet`)), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, _toDisplayString(machine?.name), 1),
                _createElementVNode("div", _hoisted_64, [
                  (machine?.dificulty == 'easy')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.easy`)), 1))
                    : _createCommentVNode("", true),
                  (machine?.dificulty == 'medium')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.medium`)), 1))
                    : _createCommentVNode("", true),
                  (machine?.dificulty == 'hard')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.hard`)), 1))
                    : _createCommentVNode("", true),
                  (machine?.dificulty == 'insane')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.insane`)), 1))
                    : _createCommentVNode("", true),
                  _hoisted_69,
                  (machine?.is_freemium)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_70, "Free"))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.moment.utc(machine?.release_at).format("DD MMMM, YYYY")), 1),
                    _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.release_date`)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, _toDisplayString(machine?.xp), 1),
                    _hoisted_78
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", {
                    class: "bg-primary rounded h-4px",
                    role: "progressbar",
                    style: _normalizeStyle('width: ' + machine?.percentage + '%'),
                    "aria-valuenow": machine?.percentage,
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, null, 12, _hoisted_80)
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("small", _hoisted_83, [
                      _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.creator`)) + " ", 1),
                      _hoisted_84
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("img", {
                          alt: "Pic",
                          src: machine?.creator?.avatar ? machine?.creator?.avatar : '/media/avatars/blank.png',
                          title: machine?.creator?.nick ? machine?.creator?.nick : 'no nick...'
                        }, null, 8, _hoisted_87)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _hoisted_89,
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("img", {
                          alt: "Pic",
                          src: 
                        machine?.first_blood ? machine?.first_blood?.avatar :  '/media/avatars/blank.png'
                      ,
                          title: machine?.first_blood ? machine?.first_blood?.nick : 'no blood...'
                        }, null, 8, _hoisted_92)
                      ])
                    ])
                  ])
                ])
              ])
            ], 8, _hoisted_47)
          ]))
        }), 128)),
        _createElementVNode("ul", _hoisted_93, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentMetadata.links, (link) => {
            return (_openBlock(), _createElementBlock("span", {
              key: link.label
            }, [
              _createElementVNode("li", {
                class: _normalizeClass('page-item m-1 cursor-pointer ' + (link.active ? 'active':''))
              }, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.goTo(link.url)),
                  class: "page-link"
                }, [
                  _createElementVNode("span", {
                    innerHTML: link.label
                  }, null, 8, _hoisted_95)
                ], 8, _hoisted_94)
              ], 2)
            ]))
          }), 128)),
          _hoisted_96,
          _createElementVNode("div", _hoisted_97, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                  _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.loading`)) + "...", 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}